import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import { loadLightStompunkterIfNeeded } from './loadLightStompunkter'

export const updateBounds = createActionCreator(actions.UPDATE_BOUNDS, 'bounds', 'view')

export function onExtentChange(bounds, view) {
    return async function(dispatch, getState) {
        dispatch(updateBounds(bounds, view))
        dispatch(loadLightStompunkterIfNeeded())
    }
}

export const zoomIn = createActionCreator(actions.ZOOM_IN)

export const zoomOut = createActionCreator(actions.ZOOM_OUT)

export const zoomToLatLng = createActionCreator(actions.ZOOM_TO_LAT_LNG, 'coords')

export function zoomToGeolocation() {
	return function(dispatch, getState) {
		if ("geolocation" in navigator) {
			navigator.geolocation.getCurrentPosition((pos) => {
				dispatch(zoomToLatLng([pos.coords.latitude, pos.coords.longitude]))
			})
		}
	}
}

// TODO: Försäkra att punkten är cachad först.
// Koden här antar att punkten redan är cachad i state.lightStompunkter
// I praktiken bör den vara det, eftersom den måste visas på kartan för att kunna klickas på.
// Men om man introducerar cache invalidation i framtiden riskerar detta att leda till buggar.
export const zoomToCurrentStompunkt = createActionCreator(actions.ZOOM_TO_CURRENT_STOMPUNKT)

export const changeBasemap = createActionCreator(actions.CHANGE_BASEMAP, 'map')



// WEBPACK FOOTER //
// ./src/actionCreators/map.js